module.exports = new __parcel__URL__("chatgpt.2e7eab8d.svg").toString();